module.exports = __webpack_public_path__ + "img/02.daed62c5.png";